import { Routes } from '@angular/router';
import { APP_ROUTE_PATHS } from '../core/routing/app-route-paths';

export const MONITORING_ROUTES: Routes = [
  {
    path: APP_ROUTE_PATHS.operator,
    loadComponent: () =>
      import('./operator-page.component').then((m) => m.OperatorPageComponent)
  }
];
